<template>
    <li>
        <div>
          <span class="mr-1" v-if="item.naceCode">({{ item.naceCode }})</span>
          <span :id="(isCustom) ? 'custom-topic-item-' + item.id : 'topic-item-' + item.id" :class="{'topic-item': item.id}" @click="$emit('treeItemClicked', {item: item, isCustom:isCustom})">{{ item.title }}</span>
          <span v-if="isFolder" @click="toggle" class="toggle-tree-item">[{{ isOpen ? '-' : '+' }}]</span>
          <span v-if="item.id" class="ml-2">
            <span v-if="isEditable" @click="$emit('treeItemEdited', item)" class="edit-tree-item" title="edit"><i class="icomoon-pencil"></i></span>
            <span v-if="!isFolder">
              <span v-if="isDeletable" @click="$emit('treeItemDeleted', item)" class="delete-tree-item" title="delete"><i class="icomoon-bin"></i></span>
            </span>
          </span>
        </div>
        <div v-if="showCriteriaCount" class="notes-below">
          <a v-if="item.criteriaDtos" @click="emitCriteriaShowEvent({item:item, isCustom:isCustom});" href="javascript:void(0);">{{ item.criteriaDtos.length + " criteria" }}&nbsp;</a>
        </div>
        <div v-if="showCustomCriteriaCount" class="notes-below">
          <a v-if="item.customCriteriaDtos" @click="emitCriteriaShowEvent({item:item, isCustom:isCustom});" href="javascript:void(0);">{{ item.customCriteriaDtos.length + " custom criteria" }}&nbsp;</a>
        </div>
        <ul v-show="isOpen" v-if="isFolder">
          <tree-item
            class="tree-item"
            v-for="(child, index) in item.childrenDtos"
            :key="index"
            :item="child"
            :is-editable="isEditable"
            :is-deletable="isDeletable"
            :is-custom="isCustom"
            :show-custom-criteria-count="showCustomCriteriaCount"
            @treeItemClicked="emitTreeItemClickedEvent"
            @treeItemDeleted="emitTreeItemDeletedEvent"
            @treeItemEdited="emitTreeItemEditedEvent"
            @criteriaShow="emitCriteriaShowEvent"
          ></tree-item>
        </ul>
    </li>
</template>
<script>
export default {
  name: "tree-item",
  props: {
    item: Object,
    isEditable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: false
    },
    isCustom: {
      type: Boolean,
      default: false
    },
    showCriteriaCount: {
      type: Boolean,
      default: false
    },
    showCustomCriteriaCount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: true
    };
  },
  computed: {
    isFolder () {
      return this.item.childrenDtos && this.item.childrenDtos.length;
    },
    questionsCounter() {
      return document.querySelectorAll('.qcounter').length
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen;
      }
    },
    emitTreeItemClickedEvent (object) {
      this.$emit('treeItemClicked', object);
    },
    emitTreeItemDeletedEvent (item) {
      this.$emit('treeItemDeleted', item);
    },
    emitTreeItemEditedEvent (item) {
      this.$emit('treeItemEdited', item);
    },
    emitCriteriaShowEvent (object) {
      this.$emit('criteriaShow', object);
    },
  }
};
</script>
<style scoped>
.topic-item {
  cursor: pointer;
}
.topic-item.active {
  text-decoration: underline;
  font-weight: bold;
}
.notes-below {
  line-height: 19px;
  font-size: 19px;
  margin-top: -5px;
}
.toggle-tree-item {
  cursor: pointer;
  margin-right: 5px;
}
.delete-tree-item {
  cursor: pointer;
  margin-left: 5px;
}
.edit-tree-item {
  cursor: pointer;
  margin-left: 5px;
}
</style>
